/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/display-name */
import { useDebounce } from '@react-hook/debounce'
import moment from 'moment'
import { FC, ReactElement, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Pagination from '../../components/pagination'
import Table from '../../components/table'
import { Patient, PatientFilter } from '../../externals/api/patients'
import { usePatients } from '../../hooks/patients'
import goAndScroll from '../../utils/goAndScroll'
import { RoutesEnum } from '../../utils/routesEnum'
import { ListContainer, PatientListInfo } from './style'

const PatientList: FC = (): ReactElement | null => {
  const [filter, setFilter] = useState({} as PatientFilter)
  const [isLoading, setIsLoading] = useState(false)
  const { get, patients } = usePatients()
  const history = useHistory()

  const [search] = useDebounce<null | string>(null)

  useMemo(() => {
    if (search !== null) {
      setFilter({ name: search, page: 1 })
    }
  }, [search])

  useMemo(() => {
    setIsLoading(true)
    get(filter).finally(() => setIsLoading(false))
  }, [setIsLoading, get, filter])

  const columns = useMemo(() => {
    return [
      {
        title: 'Nome paciente',
        dataIndex: 'name',
        render: (name: string, { _id, totalAnalysedExams }: Patient) => (
          <PatientListInfo onClick={() => history.push(RoutesEnum.PATIENTS_VIEW.replace(':patientId', _id))}>
            {name}
            <span>{totalAnalysedExams || 0} processamentos</span>
          </PatientListInfo>
        )
      },
      {
        title: 'Data do último processamento',
        dataIndex: 'createdAt',
        render: (createdAt: string) => moment(createdAt).format('DD/MM/YYYY')
      }
    ]
  }, [])

  return (
    <>
      {/* <SearchBar
        label='Procurar um paciente'
        value={search || ''}
        onChange={(e: any) => setSearch(e.target.value)}
      /> */}
      <ListContainer>
        <Table
          loading={isLoading}
          columns={columns}
          data={patients.docs}
        />
        {patients.totalPages && (
          <Pagination
            onChange={goAndScroll((page: number) => setFilter({ page }))}
            totalPages={patients.totalPages}
            page={patients.page}
          />
        )}
      </ListContainer>
    </>
  )
}

export default PatientList
